export const bookingTranslations = {
  fr: {
    hero: {
      title: 'Réservez votre appel découverte gratuit',
      subtitle1: 'Prenons 30 minutes pour faire le point sur votre situation, répondre à vos questions et identifier ensemble l\'accompagnement qui vous correspond le mieux.',
      subtitle2: 'Consultations en visioconférence Zoom ou en présentiel à Ibiza.'
    },
    
    calendly: {
      title: 'Appel découverte gratuit – 30 minutes',
      description1: 'Un premier échange gratuit pour comprendre votre situation, répondre à vos questions et voir ensemble quel accompagnement vous conviendrait le mieux.',
      description2: 'Les consultations se déroulent en visioconférence Zoom ou en présentiel à Ibiza selon vos besoins.',
      privacyBefore: 'En réservant un créneau, vous acceptez que vos données soient traitées conformément à notre ',
      privacyLink: 'Politique de confidentialité',
      privacyAfter: '. La réservation est gérée par Calendly.'
    },
    
    whyBook: {
      title: 'Pourquoi réserver cet appel découverte ?',
      reason1: 'Gratuit et sans engagement',
      reason1desc: '30 minutes pour échanger librement',
      reason2: 'Faire le point',
      reason2desc: 'Comprendre votre situation actuelle',
      reason3: 'Répondre à vos questions',
      reason3desc: 'Poser toutes vos questions en toute liberté',
      reason4: 'Trouver le bon accompagnement',
      reason4desc: 'Identifier ce qui vous conviendrait le mieux'
    },
    
    process: {
      title: 'Comment ça se passe ?',
      step1: {
        title: 'Choisissez votre créneau',
        description: 'Sélectionnez la date et l\'heure qui vous conviennent dans le calendrier ci-dessus'
      },
      step2: {
        title: 'Confirmation instantanée',
        description: 'Vous recevez immédiatement un email avec votre lien Zoom ou les détails pour la rencontre'
      },
      step3: {
        title: 'On se retrouve',
        description: 'Nous échangeons ensemble pendant 30 minutes pour voir ce qui pourrait vous aider'
      }
    },
    
    quote: {
      text: 'Je prends le temps d\'écouter chaque personne dans sa singularité. Cet appel découverte nous permet de voir ensemble ce qui pourrait vous aider aujourd\'hui.',
      author: '— Stef Ruiz'
    }
  },
  
  es: {
    hero: {
      title: 'Reserva tu llamada descubrimiento gratuita',
      subtitle1: 'Tomemos 30 minutos para hacer un balance de tu situación, responder a tus preguntas e identificar juntos el acompañamiento que mejor te convenga.',
      subtitle2: 'Consultas en videoconferencia Zoom o presencial en Ibiza.'
    },
    
    calendly: {
      title: 'Llamada descubrimiento gratuita – 30 minutos',
      description1: 'Un primer intercambio gratuito para comprender tu situación, responder a tus preguntas y ver juntos qué acompañamiento te convendría mejor.',
      description2: 'Las consultas se realizan en videoconferencia Zoom o presencial en Ibiza según tus necesidades.',
      privacyBefore: 'Al reservar una cita, aceptas que tus datos sean tratados de acuerdo con nuestra ',
      privacyLink: 'Política de Privacidad',
      privacyAfter: '. La reserva es gestionada por Calendly.'
    },
    
    whyBook: {
      title: '¿Por qué reservar esta llamada descubrimiento?',
      reason1: 'Gratis y sin compromiso',
      reason1desc: '30 minutos para hablar libremente',
      reason2: 'Hacer un balance',
      reason2desc: 'Comprender tu situación actual',
      reason3: 'Responder a tus preguntas',
      reason3desc: 'Hacer todas tus preguntas con total libertad',
      reason4: 'Encontrar el acompañamiento adecuado',
      reason4desc: 'Identificar lo que mejor te convendría'
    },
    
    process: {
      title: '¿Cómo funciona?',
      step1: {
        title: 'Elige tu franja horaria',
        description: 'Selecciona la fecha y hora que te convengan en el calendario de arriba'
      },
      step2: {
        title: 'Confirmación instantánea',
        description: 'Recibes inmediatamente un email con tu enlace Zoom o los detalles para el encuentro'
      },
      step3: {
        title: 'Nos encontramos',
        description: 'Hablamos juntos durante 30 minutos para ver qué podría ayudarte'
      }
    },
    
    quote: {
      text: 'Me tomo el tiempo de escuchar a cada persona en su singularidad. Esta llamada descubrimiento nos permite ver juntos qué podría ayudarte hoy.',
      author: '— Stef Ruiz'
    }
  }
};